import React from "react";
import {NavLink} from "react-router-dom";
const ChangedPass = () => {
    return (
        <>
            <div className="cd-pass">
                <h1 className="cd-pass--title text-jost-sb-50-wt">Change Password</h1>
                <div className="cd-pass__wrap">
                    <div className="cd-pass__box">
                        <h2 className="c-pass__box--txt text-jost-sb-22-lg">Password Changed!</h2>
                        <p className="c-pass__box--para text-ops-rg-16">Thank you message. Lorem ipsum dolor sit amet,
                            consectetur adipiscing elit. Proin eu mattis velit. Donec dictum leo vel fermentum placerat.
                            Null bibendum blandit. Praesent eu consequat dictum leovel Aenean consectetur sit amet sem
                            non maximus. Praesent dictum, odio non posuere scelerisque, diam augue sagittis arcu, vitae
                            egestas tortor ligula ut arcu sit amet sem non.</p>
                        <div className="c-pass__box--links">
                            <NavLink to="/loged-user-home" target="_self" className="res-btn-primary">BUTTON</NavLink>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default ChangedPass;